export default __webpack_public_path__ + "static/media/next-audio-5.571f0b04.mp3";